import { isObject } from './isObject';

/**
 * @description Performs a shallow inversion of an object.
 */
export const invert = (obj: Record<string, any>): Record<string, any> => {
  const inverted: Record<string, any> = {};

  Object.entries(obj).forEach(([key, val]) => {
    if (val != null) {
      inverted[val] = key;
    }
  });

  return inverted;
};

/**
 * @description Recursively removes all properties with a nil value from an object.
 * @param obj Object to clean
 * @param recurse Recursively clean object (default: true)
 * @returns Cleaned object
 */
export const clean = (obj: Record<string, any>, recurse = true): Record<string, any> => {
  const cleaned: Record<string, any> = {};

  Object.entries(obj).forEach(([key, val]) => {
    if (val != null) {
      if (recurse && isObject(val)) {
        cleaned[key] = clean(val);
      } else {
        cleaned[key] = val;
      }
    }
  });

  return cleaned;
};
